import axios from 'axios'
import router from '../router'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
})

const token = localStorage.getItem('token')
if (token) {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

export default api